import { AdTargetExceptionShortCodes, AdTargetShortCodes, IAdTargetShortCode } from './shortcodes'

export class AdTargetLookup {

    constructor(public lookup: any, public kvKey = '_kvs') { }

    public byHost(host: string, key?: string) {
        const item = host.replace('www.', '').split('.').reverse()
            .reduce((data: any, k: string) => data && data[k] || undefined, this.lookup)

        if (key) {
            try {
                return item[this.kvKey][key]
            } catch {
                return undefined
            }
        }

        return item
    }

    /**
     * byShortcode - convert domain to site shortcodes.
     */
    public byShortcode(host: string) {
        const keys = Object.keys(AdTargetShortCodes)
        const item = host.replace('www.', '').replace(/^https?:\/\//,'').split('.').shift()
        for (const _ of AdTargetExceptionShortCodes) {
            if(host.includes(_.path)) {
                return _.shortcode
            }
        }
        for (const _ of keys) {
            if(host.includes(_)) {
                return this.getIndexValue(AdTargetShortCodes, _)
            }
        }
        return this.getIndexValue(AdTargetShortCodes, item)
    }

    /**
     * Returns shortcode index value.
     */
    public getIndexValue(obj: IAdTargetShortCode, val: string) {
        return obj[val]
    }

}
